import { getFeaturePanelDefinition } from "../feature-panel-registry.ts";
import type { RuntimeFeatureModule } from "../runtime-feature-registry.ts";
import {
  applyTextEffectValue,
  resetTextEffectValue,
} from "../shared/page-text-effects.ts";
import {
  createRangeControl,
  formatNumber,
  normalizeSteppedValue,
  parseNumericConfig,
} from "../shared/feature-value.ts";

const variable = "--migrosone-a11y-letter-spacing";
const attribute = "data-migrosone-a11y-letter-spacing";
const fallback = {
  defaultValue: 0,
  min: 0,
  max: 4,
  step: 0.5,
};

function getConfig(config: unknown) {
  return parseNumericConfig({
    config,
    defaultKeys: ["letterSpacing"],
    fallback,
  });
}

const definition = getFeaturePanelDefinition("letter-spacing");

if (!definition) {
  throw new Error("Missing letter-spacing feature definition");
}

export const letterSpacingFeatureModule: RuntimeFeatureModule = {
  key: "letter-spacing",
  definition,
  isSupported({ document }) {
    return Boolean(document.head && document.documentElement);
  },
  renderControl({ config, document, onPreferenceChange, preference }) {
    return createRangeControl({
      config: getConfig(config),
      document,
      label: "Harf aralığı",
      onPreferenceChange,
      preference,
    });
  },
  apply({ config, document, preference }) {
    const numericConfig = getConfig(config);
    const value = normalizeSteppedValue(preference, numericConfig);
    applyTextEffectValue({
      attribute,
      document,
      value: `${formatNumber(value)}px`,
      variable,
    });
  },
  reset({ config, document }) {
    resetTextEffectValue({ attribute, document, variable });
    const numericConfig = getConfig(config);
    applyTextEffectValue({
      attribute,
      document,
      value: `${formatNumber(numericConfig.defaultValue)}px`,
      variable,
    });
  },
};
